module.exports = __webpack_public_path__ + "img/footer-welcome.e0a97edc.jpg";